/**
 * @generated SignedSource<<991cb73d7bf61768a3e4c9290e88e833>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$data = {
  readonly cta: string | null;
  readonly imagePath: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoButton_linkData">;
  };
  readonly subtitle: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader";
};
export type ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$key = {
  readonly " $data"?: ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imagePath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoButton_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingSplashHeader",
  "abstractKey": null
};

(node as any).hash = "fd98c2b6cedd5bb87d90006aece1fd47";

export default node;
